module.exports = __webpack_public_path__ + "static/Muli-SemiBoldItalic.157eb1ca.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-SemiBoldItalic.ttf
// module id = 341
// module chunks = 114276838955818